module.exports = __webpack_public_path__ + "assets/img/1_1647_big.c8365705.jpg";